import Configurator from "./configurator.js";
import Executor from "./executor.js";
import Corrector from "./corrector.js";
import CalculateIcon from "@mui/icons-material/Calculate";
import description from "./description.js";

export default {
  title: "Calculs mathématiques",
  icon: CalculateIcon,
  description,
  Configurator,
  Executor,
  Corrector,
};
